(function( $ ) {
    $(function() {


        $( document ).ready(function() {

            $('.scroll-up').click(function () {
                $('html, body').animate({scrollTop: '0px'}, 300);
            });

            //Tasty hamburgers
            var $hamburger = $(".hamburger");
            $hamburger.on("click", function(e) {
                $hamburger.toggleClass("is-active");
                // Do something else, like open/close menu
                $('.nav-nvp').toggleClass("is-active");
            });

            //Move selectbox "inside" subscribe input
            var selectbox = $('.dm_subscribe_field-wrap').prev();
            if(selectbox.length) {
                selectbox.remove();
                $(".subscribe__email").after(selectbox);
            }

            //Smooth Scrolling
            $(function() {
                $('a[href*="#"]:not([href="#"])').click(function() {
                    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                        if (target.length) {
                            $('html, body').animate({
                                scrollTop: target.offset().top
                            }, 1000);
                            return false;
                        }
                    }
                });
            });


            $('.ervaringen-carousel').flickity({
                // options
                arrowShape : "M4.692 61.349l33.2 33.2a12.233 12.233 0 0 0 8.682 3.594c3.136 0 6.278-1.197 8.68-3.594 4.791-4.791 4.791-12.563 0-17.356L40.329 62.274h47.403C94.508 62.27 100 56.777 100 50c0-6.776-5.492-12.268-12.268-12.268H40.329l14.925-14.925c4.791-4.793 4.791-12.565 0-17.356C50.461.66 42.689.66 37.898 5.451l-33.2 33.2c-6.263 6.256-6.263 16.437-.006 22.698z",
            });

            // http://stackoverflow.com/questions/23261301/required-attribute-not-work-in-safari-browser
            if(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                $("form").find('[type="submit"]').on('click', function (e) {
                    var form = $(this).closest('form')[0];

                    if (typeof form.checkValidity == 'function' && !form.checkValidity()) {
                        //console.log("I am Safari"); // Safari continues with form regardless of checkValidity being false
                        e.preventDefault(); // dismiss the default functionality
                        var inputs = $(form).find('input:visible[required]');

                        inputs.each(function () {
                            if (!this.validity.valid) {
                                $(this).focus();
                                $(this).attr("placeholder", this.validationMessage).addClass('placeholderError');
                                $(this).val(''); // clear value so it shows error message on Placeholder.
                                return false;
                            }
                        });
                        return false; // its invalid, don't continue with submission
                        e.preventDefault();
                    }
                });
            }

        });

    });
})(jQuery);